/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import shaka from "shaka-player";

import { CurrentAdTracker } from "./CurrentAdTracker";

export interface AdTracker {
  currentTime: number;
  duration: number;
  position: number;
  totalAds: number;
  skippable: boolean;
  skipTimeOffset: number;
  muted: boolean;
  playing: boolean;
  title: string;
  description: string;
}

export class CurrentAdTrackerShaka extends CurrentAdTracker {
  constructor(manager: google.ima.AdsManager, player: shaka.Player) {
    super(manager, player);
  }

  protected updateAdMetadata = () => {
    this.player
      .getMediaElement()
      ?.dispatchEvent(new CustomEvent("admetadataupdate"));
  };
}
